import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import SchoolInfo from '../../shared/SchoolInfo/SchoolInfo';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import classes from './registeredTeacherRegistrationStage.module.css';

const RegisteredTeacherRegistrationStage = () => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.registeredTeacherRegistrationStage}>
            <SchoolInfo />
            <BtnComponent type={ButtonType.ANCHOR} text={texts.btnPrepare} anchorId="tools-box-block" />
        </div>
    );
};

export default RegisteredTeacherRegistrationStage;

